import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBoltFilled = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 16 16",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#a)",
		children: /* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M10.968 1.55C11.365.369 9.868-.561 9.001.384L2.31 7.691c-.683.747-.164 1.966.86 1.966h3.22c.11 0 .197.11.16.226L5.103 14.47c-.374 1.184 1.127 2.087 1.98 1.14l6.614-7.348c.674-.75.153-1.959-.866-1.959H9.61a.172.172 0 0 1-.16-.228z"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "a",
		children: /* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M0 0h16v16H0z"
		})
	}) })]
});
export default SvgBoltFilled;
